module.exports = __webpack_public_path__ + "media/images/flags/zw-a70e41e8f82a4a037a40c72a48702953.svg";